import { useEmployeeDashboard } from "@/hooks/use-hr-queries";
import { initials, Page, Panel, QueryGate } from "@/components/shell/page";

const fields = [
  ["employee_code", "Employee ID"],
  ["email", "Email"],
  ["phone", "Phone"],
  ["department_name", "Department"],
  ["designation", "Designation"],
  ["work_location", "Location"],
  ["joining_date", "Joined"],
  ["employment_status", "Status"],
] as const;

export default function EmployeeProfilePage() {
  const { data, isLoading, error } = useEmployeeDashboard();
  const profile = data?.profile ?? {};

  return (
    <QueryGate loading={isLoading} error={error || !data ? "Could not load profile." : null}>
      <Page title="Profile" description="The employment record your employer keeps for you.">
        <Panel>
          <div className="flex items-center gap-4">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-lg font-semibold text-primary">
              {initials(profile.name)}
            </span>
            <div>
              <h2 className="text-xl font-semibold">{profile.name}</h2>
              <p className="text-sm text-muted-foreground">{profile.designation || "Staff"}</p>
            </div>
          </div>
          <dl className="mt-6 grid gap-4 sm:grid-cols-2">
            {fields.map(([key, label]) => (
              <div key={key}>
                <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</dt>
                <dd className="mt-1 text-sm">{profile[key] || "—"}</dd>
              </div>
            ))}
          </dl>
        </Panel>
      </Page>
    </QueryGate>
  );
}
